import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Product, TotalProductsSoldType } from 'src/app/models/core/product.model';
import { getProductIcon } from 'src/app/types/product-type-icon.map';
import { ProductOptionsModalComponent } from '../../modals/product-options-modal/product-options-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { GenerateTicketModalComponent } from '../../modals/generate-ticket-modal/generate-ticket-modal.component';

@Component({
  selector: 'app-exclusive-promotional-card',
  templateUrl: './exclusive-promotional-card.component.html',
  styleUrls: ['./exclusive-promotional-card.component.scss'],
  standalone: false
})
export class ExclusivePromotionalCardComponent implements OnInit {
  @Input() totalProductsSoldType: TotalProductsSoldType = 'percentage';
  @Input() isDirectSale: boolean = false;
  @Input() product!: Product;
  @Input() dropdownOpenId: number | null = null;
  @Input() eventId: string | number | null = null;
  @Output() toggleDropdown = new EventEmitter<number | null>();
  @Output() productDetailsRequested = new EventEmitter<any>();

  public icon: string = '';

  constructor(
    private modalCtrl: ModalController,
    private _translate: TranslateService,
  ) { }

  ngOnInit() {
    this.icon = getProductIcon(this.product?.product_type);
  }

  get isDropdownOpen(): boolean {
    return this.dropdownOpenId === this.product.id;
  }

  onToggleDropdownClick(event: MouseEvent) {
    event.stopPropagation();
    this.onToggleDropdown();
  }

  onToggleDropdown() {
    this.toggleDropdown.emit(this.isDropdownOpen ? null : this.product.id);
  }

  select() {
    this.productDetailsRequested.emit(this.product);
  }

  async openProductOptionsModal() {
    const modal = await this.modalCtrl.create({
      component: ProductOptionsModalComponent,
      componentProps: { product: this.product, isDirectSale: this.isDirectSale, eventId: this.eventId },
      breakpoints: [0, 0.5, 0.95],
      initialBreakpoint: 0.25,
      cssClass: 'product-options-modal',
      handle: true
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data?.action === 'details') {
      this.select();
    }
  }

  getSaleTagClass(message: string): string {
    if (message.includes('habilita')) return 'sale-tag sale-tag--warning';
    if (message.includes('finalizado')) return 'sale-tag sale-tag--danger';
    if (message.includes('Finaliza')) return 'sale-tag sale-tag--success';
    return 'sale-tag';
  }

  get translatedPaymentMethods(): string {
    if (!this.product?.ecommerce || !this.product?.ecommerce_payment_method) {
      return '';
    }

    let methods: string[] = [];

    try {
      methods = JSON.parse(this.product.ecommerce_payment_method);
    } catch (error) {
      console.warn('Error al parsear ecommerce_payment_method', error);
      return this._translate.instant('payment-methods.unknown');
    }

    if (!Array.isArray(methods)) return this._translate.instant('payment-methods.unknown');

    return methods
      .map(method => this._translate.instant(`payment-methods.${method}`) || '')
      .join(' / ');
  }

  onCardClick(product: Product) {
    if (this.isDirectSale) {
      this.onGenerateTicket(product);
    }
  }

  async onGenerateTicket(product: Product) {
    await GenerateTicketModalComponent.open(this.modalCtrl, product);
  }

}
